import angular from 'angular'
import PlayReportComponent from './play-report.component'

import filters from 'components/filters/filters.js'
import SceneService from 'common/scene.service'

export default angular
  .module('playReport', [
    filters,
    SceneService
  ])
  .component('playReport', PlayReportComponent)
  .name
